// Mock data for restaurant menu - brand agnostic
export const categories = [
  { id: 'popular', name: 'Más Vendidos', icon: '🔥' },
  { id: 'starters', name: 'Entradas', icon: null },
  { id: 'mains', name: 'Platos Fuertes', icon: null },
  { id: 'bowls', name: 'Bowls', icon: null },
  { id: 'sides', name: 'Acompañamientos', icon: null },
  { id: 'drinks', name: 'Bebidas', icon: null },
  { id: 'desserts', name: 'Postres', icon: null },
];

export const dietaryTags = [
  { id: 'vegetarian', label: 'Vegetariano', icon: 'V' },
  { id: 'vegan', label: 'Vegano', icon: 'VG' },
  { id: 'gluten-free', label: 'Sin Gluten', icon: 'GF' },
  { id: 'spicy', label: 'Picante', icon: '🌶' },
];

export const allergens = [
  'Gluten', 'Lácteos', 'Huevo', 'Mariscos', 'Nueces', 'Soya', 'Apio', 'Mostaza'
];

export const menuItems = [
  // POPULAR / MÁS VENDIDOS
  {
    id: 1,
    name: 'Bowl Mediterráneo',
    description: 'Base de quinoa, hummus, falafel crujiente, vegetales rostizados y salsa tahini',
    price: 189,
    category: 'popular',
    image: 'https://images.unsplash.com/photo-1512621776951-a57141f2eefd?w=600&q=80',
    tags: ['vegetarian', 'gluten-free'],
    allergens: ['Nueces'],
    prepTime: 12,
    calories: 520,
    isPopular: true,
    variants: [
      { id: 'size', name: 'Tamaño', options: [{ name: 'Regular', price: 0 }, { name: 'Grande', price: 35 }] }
    ],
    extras: [
      { id: 'protein', name: 'Proteína extra', price: 45 },
      { id: 'avocado', name: 'Aguacate', price: 35 },
    ]
  },
  {
    id: 2,
    name: 'Pollo al Limón',
    description: 'Pechuga de pollo marinada con hierbas, puré de papa y vegetales de temporada',
    price: 215,
    category: 'popular',
    image: 'https://images.unsplash.com/photo-1598515214211-89d3c73ae83b?w=600&q=80',
    tags: ['gluten-free'],
    allergens: ['Lácteos'],
    prepTime: 18,
    calories: 650,
    isPopular: true,
    variants: [],
    extras: [
      { id: 'extra-sauce', name: 'Salsa extra', price: 25 },
    ]
  },
  {
    id: 3,
    name: 'Tacos de Carnitas',
    description: 'Tres tacos de carnitas confitadas con cebolla morada, cilantro y salsa verde',
    price: 165,
    category: 'popular',
    image: 'https://images.unsplash.com/photo-1565299585323-38d6b0865b47?w=600&q=80',
    tags: ['spicy'],
    allergens: [],
    prepTime: 10,
    calories: 480,
    isPopular: true,
    spiceLevel: 2,
    variants: [
      { id: 'tortilla', name: 'Tortilla', options: [{ name: 'Maíz', price: 0 }, { name: 'Harina', price: 0 }] }
    ],
    extras: [
      { id: 'guac', name: 'Guacamole', price: 40 },
      { id: 'queso', name: 'Queso fundido', price: 35 },
    ]
  },
  // ENTRADAS
  {
    id: 4,
    name: 'Carpaccio de Res',
    description: 'Finas láminas de res con rúcula, parmesano y vinagreta de limón',
    price: 175,
    category: 'starters',
    image: 'https://images.unsplash.com/photo-1608897013039-887f21d8c804?w=600&q=80',
    tags: ['gluten-free'],
    allergens: ['Lácteos'],
    prepTime: 8,
    calories: 280,
    variants: [],
    extras: []
  },
  {
    id: 5,
    name: 'Bruschetta Clásica',
    description: 'Pan artesanal tostado con jitomate fresco, albahaca y aceite de oliva',
    price: 95,
    category: 'starters',
    image: 'https://images.unsplash.com/photo-1572695157366-5e585ab2b69f?w=600&q=80',
    tags: ['vegetarian', 'vegan'],
    allergens: ['Gluten'],
    prepTime: 6,
    calories: 220,
    variants: [],
    extras: [
      { id: 'burrata', name: 'Agregar burrata', price: 65 },
    ]
  },
  {
    id: 6,
    name: 'Ceviche del Día',
    description: 'Pescado fresco marinado en cítricos con aguacate, cebolla morada y tostadas',
    price: 185,
    category: 'starters',
    image: 'https://images.unsplash.com/photo-1535399831218-d5bd36d1a6b3?w=600&q=80',
    tags: ['gluten-free'],
    allergens: ['Mariscos'],
    prepTime: 10,
    calories: 240,
    spiceLevel: 1,
    variants: [],
    extras: []
  },
  {
    id: 7,
    name: 'Edamames con Sal de Mar',
    description: 'Vainas de soya al vapor con sal de mar y limón',
    price: 75,
    category: 'starters',
    image: 'https://images.unsplash.com/photo-1564894809611-1742fc40ed80?w=600&q=80',
    tags: ['vegetarian', 'vegan', 'gluten-free'],
    allergens: ['Soya'],
    prepTime: 5,
    calories: 120,
    variants: [],
    extras: [
      { id: 'spicy-salt', name: 'Sal con chile', price: 0 },
    ]
  },
  // PLATOS FUERTES
  {
    id: 8,
    name: 'Salmón Teriyaki',
    description: 'Filete de salmón glaseado con salsa teriyaki, arroz jazmín y vegetales al wok',
    price: 285,
    category: 'mains',
    image: 'https://images.unsplash.com/photo-1467003909585-2f8a72700288?w=600&q=80',
    tags: ['gluten-free'],
    allergens: ['Mariscos', 'Soya'],
    prepTime: 20,
    calories: 580,
    variants: [
      { id: 'cook', name: 'Término', options: [{ name: 'Medio', price: 0 }, { name: 'Bien cocido', price: 0 }] }
    ],
    extras: []
  },
  {
    id: 9,
    name: 'Risotto de Hongos',
    description: 'Arroz arborio cremoso con mezcla de hongos silvestres y parmesano',
    price: 195,
    category: 'mains',
    image: 'https://images.unsplash.com/photo-1476124369491-e7addf5db371?w=600&q=80',
    tags: ['vegetarian', 'gluten-free'],
    allergens: ['Lácteos'],
    prepTime: 22,
    calories: 620,
    variants: [],
    extras: [
      { id: 'truffle', name: 'Aceite de trufa', price: 55 },
    ]
  },
  {
    id: 10,
    name: 'Pasta Pomodoro',
    description: 'Spaghetti al dente con salsa de jitomate San Marzano y albahaca fresca',
    price: 155,
    category: 'mains',
    image: 'https://images.unsplash.com/photo-1621996346565-e3dbc646d9a9?w=600&q=80',
    tags: ['vegetarian', 'vegan'],
    allergens: ['Gluten'],
    prepTime: 15,
    calories: 480,
    variants: [
      { id: 'pasta', name: 'Tipo de pasta', options: [{ name: 'Spaghetti', price: 0 }, { name: 'Penne', price: 0 }, { name: 'Fusilli', price: 0 }] }
    ],
    extras: [
      { id: 'chicken', name: 'Agregar pollo', price: 55 },
      { id: 'shrimp', name: 'Agregar camarones', price: 75 },
    ]
  },
  {
    id: 11,
    name: 'Burger Artesanal',
    description: 'Carne de res 180g, queso cheddar, bacon crujiente, lechuga y salsa especial',
    price: 195,
    category: 'mains',
    image: 'https://images.unsplash.com/photo-1568901346375-23c9450c58cd?w=600&q=80',
    tags: [],
    allergens: ['Gluten', 'Lácteos', 'Huevo'],
    prepTime: 18,
    calories: 850,
    variants: [
      { id: 'cook', name: 'Término', options: [{ name: 'Medio', price: 0 }, { name: 'Tres cuartos', price: 0 }, { name: 'Bien cocido', price: 0 }] }
    ],
    extras: [
      { id: 'extra-patty', name: 'Carne extra', price: 65 },
      { id: 'egg', name: 'Huevo frito', price: 25 },
    ]
  },
  {
    id: 12,
    name: 'Curry Thai Verde',
    description: 'Curry cremoso con leche de coco, vegetales, tofu y arroz jazmín',
    price: 175,
    category: 'mains',
    image: 'https://images.unsplash.com/photo-1455619452474-d2be8b1e70cd?w=600&q=80',
    tags: ['vegetarian', 'vegan', 'gluten-free', 'spicy'],
    allergens: ['Soya'],
    prepTime: 16,
    calories: 520,
    spiceLevel: 2,
    variants: [
      { id: 'protein', name: 'Proteína', options: [{ name: 'Tofu', price: 0 }, { name: 'Pollo', price: 25 }, { name: 'Camarón', price: 45 }] }
    ],
    extras: []
  },
  // BOWLS
  {
    id: 13,
    name: 'Poke Bowl Salmón',
    description: 'Arroz de sushi, salmón fresco, aguacate, edamame, pepino y salsa ponzu',
    price: 225,
    category: 'bowls',
    image: 'https://images.unsplash.com/photo-1546069901-ba9599a7e63c?w=600&q=80',
    tags: ['gluten-free'],
    allergens: ['Mariscos', 'Soya'],
    prepTime: 12,
    calories: 550,
    isPopular: true,
    variants: [
      { id: 'base', name: 'Base', options: [{ name: 'Arroz', price: 0 }, { name: 'Quinoa', price: 20 }, { name: 'Mix de hojas', price: 0 }] }
    ],
    extras: [
      { id: 'extra-salmon', name: 'Salmón extra', price: 65 },
    ]
  },
  {
    id: 14,
    name: 'Buddha Bowl',
    description: 'Quinoa, garbanzos rostizados, camote, kale, aguacate y aderezo de tahini',
    price: 175,
    category: 'bowls',
    image: 'https://images.unsplash.com/photo-1540914124281-342587941389?w=600&q=80',
    tags: ['vegetarian', 'vegan', 'gluten-free'],
    allergens: ['Nueces'],
    prepTime: 14,
    calories: 480,
    variants: [],
    extras: [
      { id: 'feta', name: 'Queso feta', price: 35 },
    ]
  },
  {
    id: 15,
    name: 'Chirashi Bowl',
    description: 'Arroz de sushi con selección de pescados frescos del día y vegetales',
    price: 265,
    category: 'bowls',
    image: 'https://images.unsplash.com/photo-1579871494447-9811cf80d66c?w=600&q=80',
    tags: ['gluten-free'],
    allergens: ['Mariscos', 'Soya'],
    prepTime: 15,
    calories: 490,
    variants: [],
    extras: []
  },
  // ACOMPAÑAMIENTOS
  {
    id: 16,
    name: 'Papas Rústicas',
    description: 'Papas cortadas a mano con hierbas provenzales y aioli de la casa',
    price: 75,
    category: 'sides',
    image: 'https://images.unsplash.com/photo-1573080496219-bb080dd4f877?w=600&q=80',
    tags: ['vegetarian', 'gluten-free'],
    allergens: ['Huevo'],
    prepTime: 8,
    calories: 320,
    variants: [],
    extras: []
  },
  {
    id: 17,
    name: 'Ensalada Verde',
    description: 'Mix de lechugas orgánicas, pepino, jitomate cherry y vinagreta balsámica',
    price: 85,
    category: 'sides',
    image: 'https://images.unsplash.com/photo-1512621776951-a57141f2eefd?w=600&q=80',
    tags: ['vegetarian', 'vegan', 'gluten-free'],
    allergens: [],
    prepTime: 5,
    calories: 120,
    variants: [],
    extras: []
  },
  {
    id: 18,
    name: 'Arroz Jazmín',
    description: 'Arroz aromático cocido al vapor',
    price: 45,
    category: 'sides',
    image: 'https://images.unsplash.com/photo-1536304993881-ff6e9eefa2a6?w=600&q=80',
    tags: ['vegetarian', 'vegan', 'gluten-free'],
    allergens: [],
    prepTime: 3,
    calories: 180,
    variants: [],
    extras: []
  },
  // BEBIDAS
  {
    id: 19,
    name: 'Limonada de la Casa',
    description: 'Limonada fresca con hierbabuena y un toque de jengibre',
    price: 55,
    category: 'drinks',
    image: 'https://images.unsplash.com/photo-1621263764928-df1444c5e859?w=600&q=80',
    tags: ['vegetarian', 'vegan', 'gluten-free'],
    allergens: [],
    prepTime: 3,
    calories: 80,
    variants: [
      { id: 'size', name: 'Tamaño', options: [{ name: 'Regular', price: 0 }, { name: 'Grande', price: 20 }] }
    ],
    extras: []
  },
  {
    id: 20,
    name: 'Agua Fresca del Día',
    description: 'Preparación natural de frutas de temporada',
    price: 45,
    category: 'drinks',
    image: 'https://images.unsplash.com/photo-1534353473418-4cfa6c56fd38?w=600&q=80',
    tags: ['vegetarian', 'vegan', 'gluten-free'],
    allergens: [],
    prepTime: 2,
    calories: 90,
    variants: [],
    extras: []
  },
  {
    id: 21,
    name: 'Smoothie Verde',
    description: 'Espinaca, piña, plátano, jengibre y leche de almendra',
    price: 85,
    category: 'drinks',
    image: 'https://images.unsplash.com/photo-1610970881699-44a5587cabec?w=600&q=80',
    tags: ['vegetarian', 'vegan', 'gluten-free'],
    allergens: ['Nueces'],
    prepTime: 4,
    calories: 180,
    variants: [],
    extras: [
      { id: 'protein', name: 'Proteína en polvo', price: 25 },
    ]
  },
  {
    id: 22,
    name: 'Café Americano',
    description: 'Espresso doble con agua caliente',
    price: 45,
    category: 'drinks',
    image: 'https://images.unsplash.com/photo-1521302080334-4bebac2763a6?w=600&q=80',
    tags: ['vegetarian', 'vegan', 'gluten-free'],
    allergens: [],
    prepTime: 3,
    calories: 5,
    variants: [],
    extras: []
  },
  {
    id: 23,
    name: 'Matcha Latte',
    description: 'Té matcha ceremonial con leche de tu elección',
    price: 75,
    category: 'drinks',
    image: 'https://images.unsplash.com/photo-1536256263959-770b48d82b0a?w=600&q=80',
    tags: ['vegetarian', 'gluten-free'],
    allergens: ['Lácteos'],
    prepTime: 4,
    calories: 140,
    variants: [
      { id: 'milk', name: 'Leche', options: [{ name: 'Entera', price: 0 }, { name: 'Deslactosada', price: 0 }, { name: 'Almendra', price: 15 }, { name: 'Avena', price: 15 }] }
    ],
    extras: []
  },
  // POSTRES
  {
    id: 24,
    name: 'Tiramisú',
    description: 'Clásico italiano con mascarpone, café espresso y cacao',
    price: 95,
    category: 'desserts',
    image: 'https://images.unsplash.com/photo-1571877227200-a0d98ea607e9?w=600&q=80',
    tags: ['vegetarian'],
    allergens: ['Lácteos', 'Huevo', 'Gluten'],
    prepTime: 5,
    calories: 380,
    variants: [],
    extras: []
  },
  {
    id: 25,
    name: 'Cheesecake de Frutos Rojos',
    description: 'Cheesecake cremoso con coulis de frutos rojos de temporada',
    price: 105,
    category: 'desserts',
    image: 'https://images.unsplash.com/photo-1533134242443-d4fd215305ad?w=600&q=80',
    tags: ['vegetarian'],
    allergens: ['Lácteos', 'Huevo', 'Gluten'],
    prepTime: 5,
    calories: 420,
    isPopular: true,
    variants: [],
    extras: []
  },
  {
    id: 26,
    name: 'Brownie con Helado',
    description: 'Brownie tibio de chocolate obscuro con helado de vainilla',
    price: 95,
    category: 'desserts',
    image: 'https://images.unsplash.com/photo-1564355808539-22fda35bed7e?w=600&q=80',
    tags: ['vegetarian'],
    allergens: ['Lácteos', 'Huevo', 'Gluten', 'Nueces'],
    prepTime: 6,
    calories: 520,
    variants: [],
    extras: [
      { id: 'extra-scoop', name: 'Bola extra de helado', price: 35 },
    ]
  },
  {
    id: 27,
    name: 'Fruta de Temporada',
    description: 'Selección de frutas frescas con miel y semillas',
    price: 75,
    category: 'desserts',
    image: 'https://images.unsplash.com/photo-1490474418585-ba9bad8fd0ea?w=600&q=80',
    tags: ['vegetarian', 'vegan', 'gluten-free'],
    allergens: [],
    prepTime: 4,
    calories: 120,
    variants: [],
    extras: []
  },
];

export const combos = [
  {
    id: 101,
    name: 'Combo Express',
    description: 'Bowl + Bebida del día',
    originalPrice: 270,
    price: 235,
    image: 'https://images.unsplash.com/photo-1546069901-ba9599a7e63c?w=600&q=80',
    includes: ['Bowl a elegir', 'Bebida regular'],
    savings: 35,
  },
  {
    id: 102,
    name: 'Para Dos',
    description: '2 Platos fuertes + 2 Bebidas + Postre a compartir',
    originalPrice: 620,
    price: 520,
    image: 'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=600&q=80',
    includes: ['2 Platos fuertes a elegir', '2 Bebidas', '1 Postre'],
    savings: 100,
  },
  {
    id: 103,
    name: 'Lunch Ejecutivo',
    description: 'Entrada + Plato fuerte + Agua',
    originalPrice: 320,
    price: 265,
    image: 'https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=600&q=80',
    includes: ['Entrada del día', 'Plato fuerte a elegir', 'Agua natural'],
    savings: 55,
  },
  {
    id: 104,
    name: 'Family Pack',
    description: 'Ideal para 4 personas',
    originalPrice: 980,
    price: 850,
    image: 'https://images.unsplash.com/photo-1555939594-58d7cb561ad1?w=600&q=80',
    includes: ['4 Platos fuertes', '4 Bebidas', '2 Postres', 'Acompañamiento grande'],
    savings: 130,
  },
];

export const reviews = [
  {
    id: 1,
    name: 'María G.',
    rating: 5,
    comment: 'La comida llegó caliente y en tiempo récord. El bowl mediterráneo es delicioso.',
    date: '2024-01-15',
    order: 'Bowl Mediterráneo',
  },
  {
    id: 2,
    name: 'Carlos R.',
    rating: 5,
    comment: 'Excelente calidad y presentación. Se nota que usan ingredientes frescos.',
    date: '2024-01-14',
    order: 'Salmón Teriyaki',
  },
  {
    id: 3,
    name: 'Ana P.',
    rating: 4,
    comment: 'Muy buena opción para comer saludable. El servicio fue rápido.',
    date: '2024-01-13',
    order: 'Buddha Bowl',
  },
  {
    id: 4,
    name: 'Roberto M.',
    rating: 5,
    comment: 'Los tacos de carnitas son los mejores que he probado. Volveré pronto.',
    date: '2024-01-12',
    order: 'Tacos de Carnitas',
  },
  {
    id: 5,
    name: 'Laura S.',
    rating: 5,
    comment: 'Pedimos el combo para dos y quedamos muy satisfechos. Gran valor.',
    date: '2024-01-11',
    order: 'Combo Para Dos',
  },
  {
    id: 6,
    name: 'Fernando H.',
    rating: 4,
    comment: 'Buena experiencia en general. El risotto de hongos estaba perfecto.',
    date: '2024-01-10',
    order: 'Risotto de Hongos',
  },
  {
    id: 7,
    name: 'Patricia V.',
    rating: 5,
    comment: 'Me encanta que tienen opciones veganas deliciosas. El curry thai es increíble.',
    date: '2024-01-09',
    order: 'Curry Thai Verde',
  },
  {
    id: 8,
    name: 'Diego L.',
    rating: 5,
    comment: 'La app es muy fácil de usar y la comida siempre llega perfecta.',
    date: '2024-01-08',
    order: 'Poke Bowl Salmón',
  },
];

export const locations = [
  {
    id: 1,
    name: 'San Pedro Centro',
    address: 'Av. Vasconcelos 345, Col. Del Valle, San Pedro Garza García',
    phone: '81 1234 5678',
    hours: { open: '08:00', close: '22:00' },
    avgPrepTime: 18,
    deliveryRadius: 5,
    deliveryFee: 35,
    freeDeliveryMin: 350,
    coordinates: { lat: 25.6573, lng: -100.3692 },
  },
  {
    id: 2,
    name: 'Monterrey Centro',
    address: 'Av. Constitución 1500, Centro, Monterrey',
    phone: '81 2345 6789',
    hours: { open: '07:00', close: '23:00' },
    avgPrepTime: 20,
    deliveryRadius: 6,
    deliveryFee: 40,
    freeDeliveryMin: 400,
    coordinates: { lat: 25.6866, lng: -100.3161 },
  },
  {
    id: 3,
    name: 'Valle Oriente',
    address: 'Av. Lázaro Cárdenas 2400, Valle Oriente, San Pedro',
    phone: '81 3456 7890',
    hours: { open: '08:00', close: '22:00' },
    avgPrepTime: 15,
    deliveryRadius: 4,
    deliveryFee: 30,
    freeDeliveryMin: 300,
    coordinates: { lat: 25.6500, lng: -100.3350 },
  },
  {
    id: 4,
    name: 'Cumbres',
    address: 'Av. Paseo de los Leones 1234, Cumbres, Monterrey',
    phone: '81 4567 8901',
    hours: { open: '09:00', close: '21:00' },
    avgPrepTime: 22,
    deliveryRadius: 7,
    deliveryFee: 45,
    freeDeliveryMin: 450,
    coordinates: { lat: 25.7450, lng: -100.3800 },
  },
  {
    id: 5,
    name: 'Santa Catarina',
    address: 'Blvd. Gustavo Díaz Ordaz 567, Santa Catarina',
    phone: '81 5678 9012',
    hours: { open: '08:00', close: '21:00' },
    avgPrepTime: 20,
    deliveryRadius: 5,
    deliveryFee: 40,
    freeDeliveryMin: 380,
    coordinates: { lat: 25.6700, lng: -100.4600 },
  },
  {
    id: 6,
    name: 'Contry',
    address: 'Av. Eugenio Garza Sada 2345, Contry, Monterrey',
    phone: '81 6789 0123',
    hours: { open: '07:30', close: '22:30' },
    avgPrepTime: 17,
    deliveryRadius: 5,
    deliveryFee: 35,
    freeDeliveryMin: 350,
    coordinates: { lat: 25.6350, lng: -100.2900 },
  },
];

export const promos = [
  {
    id: 1,
    code: 'BIENVENIDO20',
    description: '20% de descuento en tu primer pedido',
    discount: 20,
    type: 'percentage',
    minOrder: 200,
    validUntil: '2024-12-31',
  },
  {
    id: 2,
    code: 'ENVIOGRATIS',
    description: 'Envío gratis en pedidos mayores a $250',
    discount: 0,
    type: 'free_shipping',
    minOrder: 250,
    validUntil: '2024-12-31',
  },
];
